/* ModalOriginalSong.js */

import React, { useCallback, useState } from 'react';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import RemixOriginalSong from '../remix/RemixOriginalSong';
import Strings from '../../translations/Translations';

export default function ModalOriginalSong({ originalSong, callback, removeOriginalSong }) {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);

  return (
    <>
      <Button className='pb-btn-1' onClick={toggle}>{Strings('upload_original_song')}</Button>

      <Modal className='pb-modal-1' isOpen={open} toggle={toggle} size='xl'>
        <ModalHeader toggle={toggle}>
          {Strings('upload_original_song')}
        </ModalHeader>
        <ModalBody>
          <RemixOriginalSong
            originalSong={originalSong}
            callback={(obj) => {
              if (obj && callback) { callback(obj); }
              toggle();
            }}
            removeOriginalSong={removeOriginalSong}
          />
        </ModalBody>
      </Modal>
    </>
  );
}
